import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { ScrollText } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit").then(({ data }) => setLogs(data)); }, []);
  const filtered = logs.filter((l) => !q || JSON.stringify(l).toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Every important change is recorded — financial records are never hard-deleted" />
      <Input placeholder="Search logs…" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-xs" data-testid="audit-search" />
      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Old</TableHead><TableHead>New</TableHead><TableHead>Reason</TableHead><TableHead>When</TableHead></TableRow></TableHeader>
          <TableBody>
            {filtered.map((l) => (
              <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                <TableCell className="font-semibold">{l.user}</TableCell><TableCell>{l.action}</TableCell><TableCell className="text-xs text-muted-foreground">{l.entity}</TableCell>
                <TableCell className="text-xs text-rose-500 max-w-[160px] truncate">{l.old_value || "—"}</TableCell>
                <TableCell className="text-xs text-emerald-500 max-w-[160px] truncate">{l.new_value || "—"}</TableCell>
                <TableCell className="text-xs">{l.reason}</TableCell><TableCell className="text-xs text-muted-foreground">{fmtDateTime(l.date)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
